export interface getCATCursoDetail{
    key: number;
    id: string;
    codigoCurso: string;
    nombre: string;
    modalidad: string;
    contacto: string;
    objetivos: string;
    nivel: number;
    competencias: string;
    perfil: string;
    metodologia: string;
    contenido: string;
    imageUrl: string
    bannerUrl: string
    iFrame: string
    certificacion: number
    phone: string

    modulo: [
        {
            id: string
            tema: string
            modulo: string
        }
    ],

    edicion: [
        
        {
            key:number
            id:string
            numeroEdicion:number
            codigoCuenta: string
            fechaDeInicioInscripcion:any
            fechaDeFinalizacionInscripcion:any
            fechaDeInicioDuracion:any
            fechaDeFinalizacionDuracion:any
            limiteCupo:number
            cupoActual:number
            edicionEspecial:boolean
            preInscripcion:boolean
            aprobadoPor:string,
            catedratico: string,

            fechasMaestria: [{
                id: 0
                catEdicionesId: number
                fechaFinal: any
                fechaInicio: any
                tipo: string
                }, {
                    id: 0
                    catEdicionesId: number
                    fechaFinal: any
                    fechaInicio: any
                    tipo: string
                }
            ],
            listaCuotas: cuotass[]
        }
    ],
    catedratico: {
        id: number
        sgPersona: any
        sgPersonaId: string
    }
}

export class getCATCursoDetail implements getCATCursoDetail{
    constructor(init?:getCATCursoDetailFormValues){
        Object.assign(this,init);
    }
}

export class getCATCursoDetailFormValues{
    key: number= 0;
    id: string="";
    codigoCurso: string = "";
    nombre: string = "";
    modalidad:  string = "";
    contacto: string = "";
    objetivos: string = ""
    imageUrl: string = ""
    bannerUrl: string = ""
    tema: string = ""
    modulo: string = ""
    numeroEdicion:number = 0
    codigoCuenta: string = ""
    fechaDeInicioInscripcion: Date | null=null
    fechaDeFinalizacionInscripcion: Date | null=null
    fechaDeInicioDuracion:Date | null=null
    fechaDeFinalizacionDuracion: Date | null=null
    limiteCupo:number = 0
    cupoActual:number = 0
    edicionEspecial:boolean = false
    preInscripcion:boolean = false
    aprobadoPor:string = ""
    iFrame: string = ""
    competencias: string = ""
    perfil: string = ''
    metodologia: string = ''
    contenido: string = ''
    certificacion: number = 0;
    catedratico: string = '';
    phone: string = '';

    nivel: number = 0
    monto: number = 0
    fechaPropedeuticoInicio: Date | null=null
    fechaPropedeuticoFinal: Date | null=null
    fechaEntrevistaInicio: Date | null=null
    fechaEntrevistaFinal: Date | null=null

    constructor(getCATCursoDetail?:getCATCursoDetailFormValues){
        if(getCATCursoDetail){
            this.id=getCATCursoDetail.id;
            this.codigoCurso=getCATCursoDetail.codigoCurso;
            this.nombre = getCATCursoDetail.nombre;
            this.modalidad = getCATCursoDetail.modalidad;
            this.contacto = getCATCursoDetail.contacto;
            this.objetivos = getCATCursoDetail.objetivos
            this.imageUrl = getCATCursoDetail.imageUrl
            this.bannerUrl = getCATCursoDetail.bannerUrl
            this.tema = getCATCursoDetail.tema
            this.modulo = getCATCursoDetail.modulo
            this.numeroEdicion = getCATCursoDetail.numeroEdicion
            this.codigoCuenta = getCATCursoDetail.codigoCuenta
            this.fechaDeInicioInscripcion = getCATCursoDetail.fechaDeInicioInscripcion
            this.fechaDeFinalizacionInscripcion = getCATCursoDetail.fechaDeFinalizacionInscripcion
            this.fechaDeInicioDuracion = getCATCursoDetail.fechaDeInicioDuracion
            this.fechaDeFinalizacionDuracion = getCATCursoDetail.fechaDeFinalizacionDuracion
            this.limiteCupo = getCATCursoDetail.limiteCupo
            this.cupoActual = getCATCursoDetail.cupoActual
            this.edicionEspecial = getCATCursoDetail.edicionEspecial
            this.preInscripcion = getCATCursoDetail.preInscripcion
            this.aprobadoPor = getCATCursoDetail.aprobadoPor
            this.iFrame = getCATCursoDetail.iFrame
            this.certificacion = getCATCursoDetail.certificacion;

            this.nivel = getCATCursoDetail.nivel
            this.fechaEntrevistaInicio = getCATCursoDetail.fechaEntrevistaInicio
            this.fechaEntrevistaFinal = getCATCursoDetail.fechaEntrevistaFinal
            this.fechaPropedeuticoInicio = getCATCursoDetail.fechaPropedeuticoInicio
            this.fechaPropedeuticoFinal = getCATCursoDetail.fechaPropedeuticoFinal

            this.competencias = getCATCursoDetail.competencias
            this.perfil = getCATCursoDetail.perfil
            this.metodologia = getCATCursoDetail.metodologia
            this.contenido = getCATCursoDetail.contenido
            this.catedratico = getCATCursoDetail.catedratico
            this.phone = getCATCursoDetail.phone

            this.monto = getCATCursoDetail.monto

        }
    }
}
export interface cuotass {
    id: number
    monto: number
}
